import { render, staticRenderFns } from "./DualooIFrame.vue?vue&type=template&id=7afa5968&"
import script from "./DualooIFrame.vue?vue&type=script&lang=js&"
export * from "./DualooIFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports